


























































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import UserInfo from '@/components/Stats/UserStats/UserInfo/index.vue';

@Component({
  components: {
    UserInfo,
  },
})
export default class UserTable extends Vue {
  @PropSync('userItems', {}) userItemSync!: [];

  @PropSync('userCount', {}) userCountSync!: [];

  @PropSync('marketSelected', {}) marketSelect!: any;

  @PropSync('loading', {}) loadings!: boolean;

  private seeList: boolean = true;

  public onClickSee() {
    this.seeList = false;
  }

  private headers = [
    {
      text: 'Name',
      align: 'left',
      value: 'userName',
      width: '350px',
    },
    {
      text: 'Role',
      align: 'left',
      value: 'userFormatedRole',
      width: '250px',
    },
    {
      text: 'Status',
      align: 'left',
      value: 'disabled',
      width: '190px',
    },
  ];
}
